import React from "react";

export const card = {
  background: "rgba(15,23,42,0.94)",
  border: "1px solid rgba(148,163,184,0.18)",
  borderRadius: 18,
  padding: 18,
  boxShadow: "0 18px 40px rgba(0,0,0,0.22)",
};
export const input = {
  width: "100%",
  padding: "11px 12px",
  borderRadius: 12,
  border: "1px solid rgba(148,163,184,0.24)",
  background: "rgba(2,6,23,0.78)",
  color: "#f8fafc",
  outline: "none",
};
export const label = { fontSize: 12, color: "#94a3b8", marginBottom: 6, display: "block", fontWeight: 700 };
export const th = { textAlign: "left", padding: 12, color: "#94a3b8", fontSize: 12, borderBottom: "1px solid rgba(148,163,184,0.16)" };
export const td = { padding: 12, borderBottom: "1px solid rgba(148,163,184,0.10)", fontSize: 13, verticalAlign: "top" };

export function Field({ labelText, children }) {
  return <div><label style={label}>{labelText}</label>{children}</div>;
}

export function Button({ children, onClick, type = "button", variant = "primary", disabled }) {
  const colors = {
    primary: "linear-gradient(135deg,#22c55e,#16a34a)",
    blue: "linear-gradient(135deg,#06b6d4,#0891b2)",
    purple: "linear-gradient(135deg,#8b5cf6,#7c3aed)",
    pink: "linear-gradient(135deg,#ec4899,#db2777)",
    muted: "rgba(148,163,184,0.12)",
    danger: "linear-gradient(135deg,#ef4444,#dc2626)",
  };
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={{
        border: variant === "muted" ? "1px solid rgba(148,163,184,0.18)" : "none",
        background: colors[variant] || colors.primary,
        color: "#fff",
        padding: "10px 14px",
        borderRadius: 12,
        fontWeight: 800,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </button>
  );
}

export function Notice({ type = "info", children }) {
  const color = type === "error" ? "#fecaca" : type === "success" ? "#bbf7d0" : "#bfdbfe";
  const borderColor = type === "error" ? "rgba(239,68,68,0.45)" : type === "success" ? "rgba(34,197,94,0.40)" : "rgba(59,130,246,0.35)";
  return <div style={{ ...card, borderColor, color, marginBottom: 14 }}>{children}</div>;
}

export function PageTitle({ title, subtitle, children }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 16, flexWrap: "wrap", marginBottom: 18 }}>
      <div>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 900 }}>{title}</h1>
        <p style={{ margin: "8px 0 0", color: "#94a3b8", maxWidth: 860, lineHeight: 1.6 }}>{subtitle}</p>
      </div>
      {children}
    </div>
  );
}

export function Stat({ value, labelText, tone = "normal" }) {
  const color = tone === "bad" ? "#fb7185" : tone === "good" ? "#86efac" : "#f8fafc";
  return <div style={{ ...card, padding: "12px 16px" }}><b style={{ color }}>{value}</b><div style={{ color: "#94a3b8", fontSize: 12 }}>{labelText}</div></div>;
}

export function TableShell({ children }) {
  return <div style={{ overflowX: "auto" }}><table style={{ width: "100%", borderCollapse: "collapse" }}>{children}</table></div>;
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}
